import React, { useRef } from 'react';
import { Modal } from '@hpi-sox/hpstellar-core';
import { Reviews, ButtonIcon, Link } from '@hpi-sox/hpstellar-core/visId';
import { X } from '@hpi-sox/hpstellar-vis-icons';

import getProductProps from '../../../../get-product-props';
import useAsyncProductData from '../../../../../hooks/useAsyncProductData';
import { withError } from '../../../../../shared/components/error-boundary';

import { ProductTitle } from '../product-details';
import { ProductStockIndicator } from '../product-details/product-labels';
import { PriceContainer, RewardBadgeContainer } from '../product-footer';
import Compare from '../product-footer/compare';
import CTARow from '../product-footer/cta-row';
import ImageGallery from './image-gallery';
import FooterSection from './footer-section';
import SpecsList from './specs-list';
import { formatSpecs } from './util';

export default withError(
    ({
        product,
        images,
        isMobile,
        visible,
        setVisible,
        analyticsData,
        options,
        translations = { offersLinkText: 'See all promo offers', specsLinkText: 'See all specs' },
    }) => {
        const { specs, loading } = useAsyncProductData(product);
        const sourceProduct = product;
        const productProps = getProductProps(sourceProduct, null, {}, {}, {}, {});
        const { ratings, productLinkProps } = productProps || {};
        const { score = 0, reviewsCount = 0, link } = ratings || {};

        const contentRef = useRef(null);

        const formattedSpecs = formatSpecs(specs);

        const closeModal = () => {
            setVisible(false);
        };
        const [expanded, setExpanded] = React.useState(true);

        const [persistentFocus, setPersistentFocus] = React.useState(true);

        return (
            <Modal
                className="quickViewModal"
                isOpen={visible}
                animationType="fade-in"
                onModalClose={closeModal}
                aria-describedby="modal-description"
                aria-labelledby="modal-title"
                horizontalAlignment="center"
                verticalAlignment="center"
                withBackdrop
                backdropClassName="quickViewBackdrop"
                focusLockProps={{
                    persistentFocus,
                    autoFocus: true,
                    disabled: false,
                }}
                initialFocusRef={contentRef}
            >
                <div className="modalContent" ref={contentRef} tabIndex={-1}>
                    <div className="modalHeader">
                        <ButtonIcon className="offers-close" onClick={closeModal} icon={<X size="s" />} size="medium" />
                    </div>
                    <div className="container">
                        <div className="leftColumn">
                            <ImageGallery images={images} variation={product.variation} />
                        </div>
                        <div className="rightColumn">
                            <ProductStockIndicator product={product} className="stock-indicator" />
                            <Reviews
                                score={score.toFixed(1)}
                                reviewsCount={reviewsCount}
                                GlobalLinkProps={{ to: link }}
                                className="product-rating"
                            />
                            <ProductTitle product={product} productLinkProps={productLinkProps} />
                            <Link to={`${productLinkProps.to}#specialOffers`} className="promoOffers">
                                {translations.offersLinkText}
                            </Link>
                            <PriceContainer product={product} isMobile={isMobile} />
                            <RewardBadgeContainer product={product} />
                            <SpecsList specs={formattedSpecs} limit={2} loading={loading}>
                                {formattedSpecs && formattedSpecs.length > 0 && (
                                    <Link className="allSpecs" onClick={() => setExpanded(!expanded)} theme="dark">
                                        {translations.specsLinkText}
                                    </Link>
                                )}
                            </SpecsList>
                            <Compare product={product} />
                            <CTARow
                                product={product}
                                productLinkProps={productLinkProps}
                                analyticsData={analyticsData}
                                options={{
                                    ...options,
                                    onClick: () => setPersistentFocus(false),
                                }}
                                isMobile={isMobile}
                            />
                        </div>
                    </div>
                    <FooterSection expanded={expanded} setExpanded={setExpanded} specs={formattedSpecs} />
                </div>
            </Modal>
        );
    },
);
